<button
    type="button"
    class="sh-pure-icon-button -sh-raised filter-panel-toggle"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="panelId"
    [attr.aria-label]="(open ? 'filter-panel.hide' : 'filter-panel.show') | translate"
    [attr.title]="(open ? 'filter-panel.hide' : 'filter-panel.show') | translate"
    (click)="toggled.emit()"
>
    <svg
        sh-icon
        [name]="open ? 'angle-double-left' : 'angle-double-right'"
        [size]="iconSize.SMALL"
        aria-hidden="true"
        class="sh-icon-button__icon"
    ></svg>
</button>
